<button odxButton (click)="resetButtonClicked.emit()" variant="secondary">
  <odx-icon name="reset" alignLeft></odx-icon>
  <span i18n="@@resetSelection.title">Auswahl zurücksetzen</span>
</button>
